module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"FiscalPOP - Facturación Electrónica Personal y para eCommerce","short_name":"FiscalPOP","start_url":"/","background_color":"#AE1F79","theme_color":"#AE1F79","display":"minimal-ui","icon":"src/images/assets/icon-96x96.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"fb07e4e2f7e585577345fd7bb64b6850"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
